export default "__VITE_ASSET__7019bb39__"